import { getCookie } from '../../../services/cookies';
import countrySettings from '../countrySettings.json';
import PatientFormCL from './PatientFormCL';
import PatientFormPE from './PatientFormPE';

const COMPONENTS = { CL: PatientFormCL, PE: PatientFormPE };

const PatientForm = (props) => {
  const countryCode = getCookie('country_code');
  const variant = countrySettings.componentVariant.patientForm[countryCode] ?? 'CL';
  const Component = COMPONENTS[variant];
  return <Component {...props} />;
};

export default PatientForm;
